import React from "react";
import PropTypes from "prop-types";
import { Box } from "@mui/material";

export default function UltraWideBgSection({ backgroundColor = "tertiary.main", children, ...props }) {
  return (
    <Box
      backgroundColor={backgroundColor}
      marginLeft={1}
      marginRight={1}
      borderRadius={2}
      paddingTop={2}
      paddingBottom={2}
      {...props}
    >
      {children}
    </Box>
  );
}

UltraWideBgSection.propTypes = {
  backgroundColor: PropTypes.string,
  children: PropTypes.node.isRequired,
};
